import { render, staticRenderFns } from "./InputTag.vue?vue&type=template&id=25714a72&scoped=true"
import script from "./InputTag.vue?vue&type=script&lang=js"
export * from "./InputTag.vue?vue&type=script&lang=js"
import style0 from "./InputTag.vue?vue&type=style&index=0&id=25714a72&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25714a72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25714a72')) {
      api.createRecord('25714a72', component.options)
    } else {
      api.reload('25714a72', component.options)
    }
    module.hot.accept("./InputTag.vue?vue&type=template&id=25714a72&scoped=true", function () {
      api.rerender('25714a72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Core/components/InputTag.vue"
export default component.exports